import { render, staticRenderFns } from "./admin-generatekey.vue?vue&type=template&id=a2c18aba&"
import script from "./admin-generatekey.vue?vue&type=script&lang=js&"
export * from "./admin-generatekey.vue?vue&type=script&lang=js&"
import style0 from "./admin-generatekey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports